export const numToMoney = num => {
  num = Number(num)
  const isLessThanZero = num < 0
  if (Math.abs(num) < 10000) {
    return num
  } else {
    num = Math.abs(num)
    let str = `${Math.floor(num / 10000)}万`
    str += (num % 10000).toFixed(2)
    str = `${isLessThanZero ? '-' : ''}${str}`
    return str
  }
}



// WEBPACK FOOTER //
// ./src/utils/string.js